import { Link } from "react-router-dom";

// Mirrors newEntityNotificationMessage (used after creating a design package)
// so a split reads the same way, but names both packages: the backend's own
// "Design package split successfully" says nothing about which is which.
export const splitDesignPackageNotification = (props: {
  projectId: string;
  newDesignPackageId: string;
  sourceTitle: string;
  newTitle: string;
}) => {
  const { projectId, newDesignPackageId, sourceTitle, newTitle } = props;
  return {
    message: (
      <div className="notifications space-x-1">
        <span className="notification-highlight-title">{sourceTitle}</span>
        <span className="notification-title">split successfully into</span>
        <span className="notification-highlight-title">{newTitle}</span>
      </div>
    ),
    description: (
      <div className="notifications space-x-1">
        <span className="notification-subTitle">Click</span>
        <Link
          className="underline notification-highlight-subTitle"
          to={{
            pathname: `/project/${projectId}/design-packages/${newDesignPackageId}`
          }}
          data-testid="split-dp-view-link"
        >
          here
        </Link>
        <span className="notification-subTitle">
          to view the new design package.
        </span>
      </div>
    ),
    placement: "top" as const
  };
};
